import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {Col, Container, H5, H6, Paragraph, Row} from '@modifi/ui'

import {CardWrapper} from './styles'
import Picture from '../../ui/cms-picture'
import SeparatorCol from './SeparatorCol'
import {DefaultComponentWrapper} from '../common'

const propTypes = {
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      headline: PropTypes.string,
      description: PropTypes.string,
      image: PropTypes.string.isRequired,
    })
  ),
  showConnector: PropTypes.bool.isRequired,
  cardType: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  hasMoreSpacingInBetween: PropTypes.bool,
}
const defaultProps = {
  cards: [],
  backgroundColor: undefined,
  hasMoreSpacingInBetween: false,
}

export type ConnectedCardsProps = InferPropTypes<typeof propTypes, typeof defaultProps>

export const ConnectedCards: React.FC<ConnectedCardsProps> = ({
  cards,
  showConnector,
  cardType,
  backgroundColor,
  hasMoreSpacingInBetween,
}) => (
  <DefaultComponentWrapper backgroundColor={backgroundColor}>
    <Container>
      <Row justifyContent={hasMoreSpacingInBetween ? 'around' : 'center'}>
        {cards?.map((card, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <React.Fragment key={`connected-card-${index}`}>
            <Col col="auto" my={16} mx={hasMoreSpacingInBetween ? 16 : 8} style={{padding: 0}}>
              <CardWrapper cardType={cardType}>
                <Picture alt={card?.headline || ''} src={card?.image} objectFit="contain" />
                {card?.headline &&
                  (hasMoreSpacingInBetween ? (
                    <H5 mb={0}>{card.headline}</H5>
                  ) : (
                    <H6 mb={0}>{card.headline}</H6>
                  ))}
                {card?.description && <Paragraph>{card.description}</Paragraph>}
              </CardWrapper>
            </Col>
            {showConnector ? <SeparatorCol cardType={cardType} /> : null}
          </React.Fragment>
        ))}
      </Row>
    </Container>
  </DefaultComponentWrapper>
)

ConnectedCards.propTypes = propTypes

ConnectedCards.defaultProps = defaultProps

export default ConnectedCards
